<template>
    <Card :title="translate('labels.price_template_page.price_template')" v-if="loaded">
        <form @submit.prevent="update">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <FormGroup :label="translate('labels.name')" required>
                            <Input type="text" v-model="name"/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <FormGroup :label="translate('labels.price_template_page.formula')">
                            <Formula v-model:formula="formula" :items="formulaVariables"/>
                            <span class="form-text text-muted" v-html="translate('labels.formula_symbols_info')"></span>
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <FormGroup :label="translate('labels.rounding_to')">
                            <Input v-model="roundingStep" type="number"/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <AppSwitch v-model="showInOrder">
                            {{ translate('labels.price_template_page.show_in_order') }}
                        </AppSwitch>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-between align-items-center">
                <div class="list-icons text-muted">
                    <span class="list-icons-item">
                        <i class="icon-plus3 mr-2"></i> {{ DateFormatter.formatDateTime(createdAt) }}
                    </span>

                    <span class="list-icons-item ml-3">
                        <i class="icon-pencil mr-2"></i> {{ DateFormatter.formatDateTime(updatedAt) }}
                    </span>
                </div>
                <div>
                    <AppButton color="light" @click="remove" class="mr-2">
                        <i class="icon-trash mr-2"></i>
                        {{ $t('buttons.delete') }}
                    </AppButton>
                    <AppButton color="indigo" type="submit">
                        <i class="icon-floppy-disk mr-2"></i>
                        {{ $t('buttons.edit') }}
                    </AppButton>
                </div>
            </div>
        </form>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import Formula from "../../../../components/form/FormulaComponent.vue";
import AppSwitch from "../../../../components/new/form/switch/AppSwitch.vue";

import MessageNotificator from "../../../../services/MessageNotificator";
import DateFormatter from "../../../../services/DateFormatter";
import { httpClient } from "../../../../services/HttpClient";
import { PriceTemplateApi } from "../../../api/PriceTemplateApi";
import { CustomFieldApi } from "../../../api/CustomFieldApi";

export default {
    name: "PriceTemplateEditPage",
    components: {
        Card, AppButton, FormGroup, Input, Formula, AppSwitch
    },
    data() {
        return {
            DateFormatter,
            loaded: false,
            uuid: null,
            name: "",
            formula: "",
            roundingStep: null,
            showInOrder: false,
            createdAt: null,
            updatedAt: null,
            customFields: [],
            dropshippers: []
        }
    },
    computed: {
        formulaVariables() {
            let variables = [
                { code: '{$categoryMarkup}', name: translate('labels.category_type_markup') },
                { code: '{$cost}', name: translate('labels.cost') },
            ];

            this.customFields.map((customField) => variables.push({
                code: `{$customField[${customField.id}]}`,
                name: customField.title
            }))

            this.dropshippers.map((dropshipper) => variables.push({
                code: `{$dropshipper[${dropshipper.uuid}]}`,
                name: translate('labels.purchase_price', { seller: dropshipper.name })
            }))

            return variables;
        }
    },
    methods: {
        removeSpacesFromFormula(formula) {
            return formula.replace(/\s+/g, '');
        },
        async fetchPriceTemplate() {
            let priceTemplate;

            try {
                priceTemplate = await PriceTemplateApi.find(this.$route.params.projectUuid, this.$route.params.priceTemplateUuid);
            } catch (error) {
                this.$router.push({ name: 'PriceTemplatesIndexPage' });

                return;
            }

            this.uuid = priceTemplate.uuid;
            this.name = priceTemplate.name;
            this.formula = priceTemplate.formula;
            this.roundingStep = priceTemplate.roundingStep;
            this.showInOrder = priceTemplate.showInOrder;
            this.createdAt = priceTemplate.createdAt;
            this.updatedAt = priceTemplate.updatedAt;
            this.loaded = true;
        },
        async fetchCustomFields() {
            this.customFields = await CustomFieldApi.findAll(this.$route.params.projectUuid, {
                models: ['product-item'],
                types: ['number'],
                limit: 0
            });
        },
        async fetchDropshippers(projectUuid) {
            let response = await httpClient.get('/dropshippers', {
                customer_project_uuids: [projectUuid],
                extra: 1,
                limit: 0
            });

            this.dropshippers = response.data.data;
        },
        async update() {
            await PriceTemplateApi.edit(this.$route.params.projectUuid, {
                name: this.name,
                formula: this.removeSpacesFromFormula(this.formula),
                rounding_step: this.roundingStep,
                show_in_order: this.showInOrder
            }, this.uuid);

            new MessageNotificator().success(this.$t('alerts.success'));
        },
        remove() {
            new MessageNotificator().confirm(translate('alerts.delete_price_template'), async () => {
                await PriceTemplateApi.remove(this.$route.params.projectUuid, this.uuid);
                this.$router.push({ name: 'PriceTemplatesIndexPage' });
            });
        }
    },
    async mounted() {
        this.fetchCustomFields();

        this.fetchPriceTemplate();

        this.fetchDropshippers(this.$route.params.projectUuid);
    }
}
</script>
